import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useRecordContext, useNotify } from 'react-admin';
import { useDispatch, useSelector } from 'react-redux';
import {
  ClearMessage,
  showMerchantConfirmPasswordModal,
} from '../../redux/creates-action/ConfirmPasswordAction';
import { RemoveCircleOutline } from '@mui/icons-material';
import FontSize from '../layout/FontSize';
import Color from '../layout/color/Color';


const closeSmallButton = {
  bgcolor: Color.Close,
  borderRadius: '30px',
  border: "1px solid #ccc",
  color: Color.Button,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};

export default function CustomDeleteButton(props) {
  const record = useRecordContext(props);
  const [message, setMessage] = useState('');

  const notify = useNotify();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.password.data);

  useEffect(() => {
    if (data.notify !== '') {
      setMessage(data.notify);
    }
  }, [data.notify]);

  useEffect(() => {
    if (message !== '') {
      notify(message, { type: data.style });
      dispatch(ClearMessage());
    }
  }, [message]);

  const handleOpen = () => {
    dispatch(
      showMerchantConfirmPasswordModal(
        `Are you sure to delete this category?`,
        'Please enter password to confirm.',
        record,
        'DELETE_CATEGORY'
      )
    );
  };

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        startIcon={<RemoveCircleOutline />}
        color="error"
        sx={closeSmallButton}
      >
        Delete
      </Button>
    </>
  );
}
